import type { ReactNode } from 'react';
import { EmptyState } from '@playerbase/ui';

type ComingSoonEmptyStateProps = {
  title: string;
  description: string;
  cta?: ReactNode;
};

export function ComingSoonEmptyState({
  title,
  description,
  cta,
}: ComingSoonEmptyStateProps): JSX.Element {
  return (
    <EmptyState
      eyebrow="Coming soon"
      title={title}
      description={description}
      cta={cta}
    />
  );
}
